import { Box, FileInput, FileInputProps, Text } from 'grommet';

export type FileUploaderProps = {
  handleFileUpload: FileInputProps['onChange'];
  acceptedFormats: string[]; // array of file extensions
  uploading?: boolean;
  maxFileSize?: string;
  dropPrompt?: string;
  uploadType?: string;
};

export const FileUploader = ({
  handleFileUpload,
  acceptedFormats,
  uploading,
  maxFileSize,
  dropPrompt,
  uploadType = 'file',
}: FileUploaderProps) => {
  const accepted = acceptedFormats.map((format) => (format[0] === '.' ? format : `.${format}`));

  return (
    <Box gap="xsmall">
      <FileInput
        name="file"
        onChange={handleFileUpload}
        disabled={uploading}
        multiple={false}
        accept={accepted.join(',')}
        messages={{
          dropPrompt: dropPrompt || `Drop ${uploadType.toLocaleLowerCase()} here or click to browse`,
          browse: 'Browse',
        }}
      />
      <Box direction="row" gap="xsmall">
        {maxFileSize && (
          <Text size="xsmall">
            Max file size: <span style={{ fontWeight: 600 }}>{maxFileSize}</span>.
          </Text>
        )}

        <Box direction="row" gap="xxsmall">
          <Text size="xsmall">
            Accepted formats: <span style={{ fontWeight: 600 }}>{accepted.join(', ')}</span>.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
